import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CreateContentFolderDocument } from './create.generated';

export const useCreateContentFolder = (
  options: ApiOptions<typeof CreateContentFolderDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(CreateContentFolderDocument, {
    ...useNotifications(CreateContentFolderDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.content_folders.create_success'),
    }),

    ...options,
  });
};
